import {Stack} from "@mui/material";

import {TIMERANGE_COLOR_FOR_UNACCREDITED_PERFORMERS} from "./TimeslotDetailedItemRenderer";
import {isPerformerNotAccreditedForShift} from "../../helpers/ShiftHelper";
import {buildBookableServiceBookableSessionColor} from "../../helpers/ServiceTypeUtils";

export const TIMESLOT_BORDER_COLOR_DARK_GREY = "#555555";

const ShiftItemRenderer = ({ item, getItemProps }) => {

    const bookableServiceSessionColorMap = item.serviceType.map(serviceType => buildBookableServiceBookableSessionColor(serviceType));
    
    const {actualShiftStartTime, shiftEndTime, serviceType} = item;
    const backgroundColors = isPerformerNotAccreditedForShift(actualShiftStartTime, shiftEndTime, serviceType)
        ? bookableServiceSessionColorMap
        : [...bookableServiceSessionColorMap, TIMERANGE_COLOR_FOR_UNACCREDITED_PERFORMERS];

    const background = backgroundColors.length === 1
        ? backgroundColors
        : `linear-gradient(to bottom, ${backgroundColors.map((color, index) => {
            return `${color} ${index * (100 / backgroundColors.length)}%, ${color} ${(index + 1) * (100 / backgroundColors.length)}%`;
        }).join(", ")})`;

    const style = {
        background,
        height: "1.25rem",
        padding: "0.125rem",
        color: item.color,
    };

    return (
        <Stack {...getItemProps({ className: "session-container", title: "", style })} />
    );
};

export default ShiftItemRenderer;